import { makeStyles } from '@material-ui/core/styles'
const useStyles = makeStyles(
  () => ({
    root: {
      background: '#FFF',
      width: '2px',
      margin: '0 0.3em 0 0.3em',
      opacity: 0.88,
    },
    header: {
      width: '100%',
      height: '57px',
      background: '#F37320',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    left: {
      padding: '1em 1em 1em 1.5em',
      display: 'flex',
      alignItems: 'center',
    },
    leftText: {
      margin: '0 0 0 1em',
      display: 'flex',
    },
    leftTextStyle: {
      fontFamily: 'Source Sans Pro,sans-serif',
      color: '#FFF',
      fontWeight: 'bold',
      opacity: 0.88,
      fontSize: '0.85rem',
      letterSpacing: '0px',
    },
    right: {
      color: '#FFF',
      letterSpacing: '0px',
      fontSize: '0.95rem',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-end',
      // width: '500px',
      marginRight: '50px',
    },
    useroptions: {
      zIndex: '2',
      position: 'absolute',
      top: '50px',
      width: '200px',
      right: '35px',
      borderRadius: '10px',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-start',
      alignItems: 'center',
    },
    useroption: {
      height: '35px',
      width: '160px',
      marginTop: '5px',
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'center',
      cursor: 'pointer',
    },
    text: { color: '#6F6F6F', fontSize: '14px', fontWeight: 'bold' },
  }),
  { index: 1 },
)

export { useStyles }
